/**
 * Bid-meeting-notices template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeSplitTextBanner from './lib/partials/ThemeSplitTextBanner';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Bid-meeting-notices';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initThemeSplitTextBanners();
}

/**
 * initThemeSplitTextBanners - Initialize the theme split text banners
 */
const initThemeSplitTextBanners = () => {
	Logger.info(`${NAME} > initThemeSplitTextBanners`);
	const themeSplitTextBanners = document.querySelectorAll('[data-theme-split-text-banner]');
	themeSplitTextBanners.forEach(themeSplitTextBannerDom => {
		const themeSplitTextBanner = new ThemeSplitTextBanner(themeSplitTextBannerDom);
		themeSplitTextBanner.init();
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
